import { render, staticRenderFns } from "./MipackKanban.vue?vue&type=template&id=01d68aa4&"
import script from "./MipackKanban.vue?vue&type=script&lang=js&"
export * from "./MipackKanban.vue?vue&type=script&lang=js&"
import style0 from "./MipackKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports